import { FC } from "react"
import { Pencil, Trash2 } from "lucide-react"
import { LoanOfficer } from "../../../../types"
import BreadCrumbs from "../../breadcrumbs"
import { Button } from "../../buttons"
import RoundedImg from "../../rounded-img"

interface Props {
  loanOfficer: LoanOfficer
  onClickEdit: (uid: string) => void
  onClickDelete: (uid: string) => void
}

const LoanOfficerDetailsHeader: FC<Props> = ({
  loanOfficer,
  onClickEdit,
  onClickDelete
}) => (
  <div className="p-6 bg-gradient-to-r from-white to-slate-50 border-b border-slate-200">
    <BreadCrumbs
      pages={[
        {
          name: "Loan officers",
          href: "/loan-officers",
          current: false
        },
        {
          name: loanOfficer.name,
          href: "#",
          current: true
        }
      ]}
    />

    <div className="py-6 flex items-center justify-between">
      <div className="flex items-center gap-5">
        <div className="relative">
          <div className="h-20 w-20 rounded-full ring-4 ring-primary-100 ring-offset-2 overflow-hidden">
            <RoundedImg
              src={loanOfficer.picture}
              alt={`${loanOfficer.name} Thumbnail`}
            />
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-serif font-bold text-slate-900">
            {loanOfficer.name}
          </h1>
          <div className="flex items-center gap-3 mt-1 text-sm text-slate-600">
            <span>{loanOfficer.email}</span>
            <span className="w-1 h-1 rounded-full bg-slate-300" />
            <span>ID: {loanOfficer.loid}</span>
            <span className="w-1 h-1 rounded-full bg-slate-300" />
            <span>NMLS {loanOfficer.nmls || "N/A"}</span>
          </div>
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          className="bg-white border border-slate-200 hover:bg-primary-50 hover:text-primary-600 hover:border-primary-300 transition-colors"
          onClick={() => onClickEdit(loanOfficer.loid ?? "")}
        >
          <Pencil size={16} className="mr-2" />
          Edit Profile
        </Button>
        <Button
          className="bg-white border border-slate-200 hover:bg-red-50 hover:text-red-600 hover:border-red-300 transition-colors"
          onClick={() => onClickDelete(loanOfficer.loid ?? "")}
        >
          <Trash2 size={16} className="mr-2" />
          Delete
        </Button>
      </div>
    </div>
  </div>
)

export default LoanOfficerDetailsHeader
